import { render, staticRenderFns } from "./EnrolmentVerifyPopup.vue?vue&type=template&id=63d1a646&"
import script from "./EnrolmentVerifyPopup.vue?vue&type=script&lang=js&"
export * from "./EnrolmentVerifyPopup.vue?vue&type=script&lang=js&"
import style0 from "./EnrolmentVerifyPopup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports